module.exports = __webpack_public_path__ + "img/water2.bb50298b.png";